export const Card = require('../../src/front/Plans/Card').default;
export const ListSlick = require('../../src/front/Plans').PlanListSlick;
export const FavoriteIndex = require('../../src/front/Plans').FavoritePlanIndex;
export const PlanShow = require('../../src/front/Plans').PlanShow;
